import { render, staticRenderFns } from "./pindah_nop.vue?vue&type=template&id=34d945dd&"
import script from "./pindah_nop.vue?vue&type=script&lang=js&"
export * from "./pindah_nop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports